<template>
  <div class="createAn1-box">
    <div
      v-for="(item, index) in pladObj"
      :key="index"
      class="inlineblock left-box"
      :class="{ an1Active: item.laber }"
      @click="item.laber = !item.laber"
    >
      <el-image :src="item.pic" alt="" fit="contain" class="image"/>
      <ul class="rightUl">
        <li class="list1">{{ item.title }}</li>
        <li class="list2">¥ {{ item.priceMin }} 起</li>
        <li class="list3">{{ item.description || "未设置" }}</li>
        <li class="list4" @click.stop="getDetails">查看详情</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["planData"],
  data() {
    return {
      imgUrl2: require("../assets/images/chuagnjian2.png"),
      imgUrl1: require("../assets/images/chaungjian1.png"),
      an1Active: null,
    };
  },

  computed: {
    pladObj: function () {
      this.planData.forEach((item) => {
        let arrMin = [
          item.price_ios,
          item.price_web,
          item.price_applet,
          item.price_android,
        ];
        arrMin = arrMin.filter((item) => {
          return item != "0.00";
        });
        // 找到4个终端的最小值。
        item.priceMin = Math.min(...arrMin);
        item.priceMin = isNaN(item.priceMin) ? item.price : item.priceMin
      });
      return this.planData;
    },
  },

  methods: {
    getDetails: function () {
      this.$message("装修进行中。");
      return;
    },
  },
};
</script>
<style lang="scss" scoped>

.createAn1-box {
  text-align: center;
  width: calc(100% + 20px);
  margin-top: 30px;
  .inlineblock {
    display: inline-block;
    padding-right: 105px;
    height: 283px;
    background: #ffffff;
    border: 2px solid #eef2f7;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    margin-bottom: 10px;
    vertical-align: middle;
    .image {
      float: left;
      width: 166px;
      height: 100%;
      margin-right: 10px;
      border: none !important;
    }
    .rightUl {
      float: left;
      min-width: 169px;
      width: 169px;
      text-align: left;
      padding-top: 38px;
      .list1 {
        color: #2d3748;
        font-size: 18px;
        margin-bottom: 10px;
      }
      .list2 {
        color: #ff2020;
        font-size: 18px;
      }
      .list3 {
        font-size: 12px;
        color: #999999;
        line-height: 25px;
        height: 80px;
      }
      .list4 {
        width: 114px;
        height: 32px;
        background: #1890ff;
        box-shadow: 0px 3px 6px rgba(24, 144, 255, 0.3);
        border-radius: 16px;
        color: #fff;
        text-align: center;
        line-height: 32px;
        margin-top: 20px;
        cursor: pointer;
      }
      .list4:active {
        background: #2d97fa;
      }
    }
  }

  .right-box {
    margin-left: 20px;
  }

  .an1Active {
    border-color: #1890ff;
  }
}

.left-box {
  margin-right: 2%;
  // margin: 0 2%;
}

@media screen and (max-width: 1200px) {
  .createAn1-box {
    width: 100% !important;
  }

  .left-box {
    margin-right: 0 !important;
    margin-bottom: 20px;
    padding: 20px !important;
    width: 96% !important;
    box-sizing: border-box;
  }
  .createAn1-box .inlineblock img {
    width: 8rem !important;
  }

  .inlineblock {
    height: auto !important ;
  }
  .inlineblock .rightUl {
    min-width: 155px !important;
    width: 160px !important;
    padding-top: 10px !important;
    margin-left: 10px !important;
  }
}
</style>
